import { clsx, type ClassValue } from "clsx";
import { DateTime } from "luxon";
import { twMerge } from "tailwind-merge";

export const timezone = "Europe/Paris";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export class DateHelper {
  static startOfDay = (date: Date = new Date()) =>
    DateTime.fromJSDate(date).setZone(timezone).startOf("day").toJSDate();

  static endOfDay = (date: Date = new Date()) =>
    DateTime.fromJSDate(date).setZone(timezone).endOf("day").toJSDate();
}

export const formatDate = (date: Date = new Date(), pattern = "dd/MM/yyyy") =>
  DateTime.fromJSDate(new Date(date)).setZone(timezone).toFormat(pattern);

export const formatLocal = (date: Date | number, pattern: string) =>
  DateTime.fromJSDate(new Date(date)).setLocale("fr").toFormat(pattern);

export const getYearFromDate = (date: Date) =>
  DateTime.fromJSDate(new Date(date)).setZone(timezone).toFormat("yyyy");

export const formatRate = (rate: number | null) =>
  rate === null ? "-" : `${(rate * 100).toFixed(1)}%`;
